import React, {useEffect, useState} from 'react';
import CanvasJSChart from "../dashboard/CanvasJSChart";
import SpinnerDiv from "../gdpr/ui/SpinnerDiv";
import {getPanelHeader} from "./DashboardPanelFunctions";
import {getDataFromResponse} from "../DataFunctions/BaseDataFns";
import VSFallbackComponent from "./FallbackComponent";
import {ErrorBoundary} from "react-error-boundary";
import {getUsageSummary} from "../DataFunctions/StatisticsDataFns";
import './AdminDashboard.scss'
import DropdownAccessHours from "./ui/DropdownAccessHours";
import DropdownSchools from "./ui/DropdownSchools";
import {getColorForUserType} from "./GraphCommonFns";

const UsagePie = (props) =>
{
    const [data, setData] = useState({loading: true, data: [], dataPoints: []})
    const ahIdProvided = props.ah_id === null || props.ah_id === undefined ;
    const [ ah_id, setAHId ] = useState ( ahIdProvided ? 0 : props.ah_id ) ;
    const [ school_id, setSchoolId ] = useState (  props.school_id) ;

    useEffect(() =>
    {
        getServerData(school_id, ah_id);
    }, [school_id, ah_id]);

    const getServerData = (school_id, in_school_hours) =>
    {
        const selected_school = school_id === undefined ? props.school_id : school_id;

        getUsageSummary(selected_school, 0, 'totals', in_school_hours, 'year', (response) =>
        {
            const reportData = getDataFromResponse(response);
            let dataPoints = generatePieChartData ( reportData )  ;

            setData({loading: false, dataPoints: dataPoints, data: reportData});
        });
    }

    const generatePieChartData = ( chartData ) =>
    {
        return chartData.filter((item) => {
            return item.tag !== 'total' ;
        })
            .map ((item) => {
                return ({
                    y: item.count,
                    label: item.name,
                    color: getColorForUserType ( item),
                    cursor: 'pointer',
                    click: () => onRowClick(item.name)
                })
            });
    }

    const rowExtResPie = () =>
    {
        let options = {
            backgroundColor: '#ffffff',
            exportEnabled: true,
            animationEnabled: true,
            data: [{
                type: "pie",
                startAngle: 75,
                toolTipContent: "<b>{label}</b>: {y}",
                showInLegend: "true",
                legendText: "{label}",
                indexLabelFontSize: 16,
                indexLabel: "{label} - {y}",
                dataPoints: data.dataPoints
            }]
        }

        return <CanvasJSChart key='UsageCanvas2' options={options} uniqueId={'UsageCanvas2'} />
    }

    const onSchoolDropdownChange = ( evt, options ) =>
    {
        if ( options.action === 'select-option')
        {
            const value = evt.value;
            setSchoolId ( value) ;
        }
    };

    const onAHDropdownChange = ( evt, options ) =>
    {
        if ( options.action === 'select-option')
        {
            const value = evt.value;
            setAHId ( value) ;
        }
    };

    if ( data.loading === true )
    {
        return <SpinnerDiv />
    }
    else
    {
        return (
            <ErrorBoundary FallbackComponent={VSFallbackComponent}>
                <div className={'panel ' + props.panelStyle}>
                    {props.title !== '' && getPanelHeader({title: props.title})}
                    <div className='panel-body'>
                        { rowExtResPie() }
                        {data.data.length === 0 && <div> <h4>Sorry there was no data found for this choice.</h4></div>}
                    </div>

                    <div className='panel-body'>
                        { props.school_id === 0 && <div className='col-md-6'>
                            <DropdownSchools onChange={onSchoolDropdownChange}
                                             id='InputSchoolDropdown'
                                             label='Select a School'
                                             defaultValue={0}
                                             isClearable={false}
                                             value={school_id}
                                             readOnly={''}
                                             key='InputSchoolDropdown'
                                             renderErrorDiv={false}
                                             menuPlacement={'top'}/>
                        </div>}

                        <div className='col-md-6'>
                            <DropdownAccessHours onChange={onAHDropdownChange}
                                                  id='InputAHDropdown'
                                                  label='Select in School Hours/Outside School'
                                                  defaultValue={2}
                                                  isClearable={false}
                                                  value={ah_id}
                                                  readOnly=''
                                                  key='InputAHDropdown'
                                                  menuPlacement={'top'}
                                                  renderErrorDiv={false}/>
                        </div>
                    </div>
                </div>
            </ErrorBoundary>
        )
    }
}

export default UsagePie;

UsagePie.defaultProps =
    {
        title: 'title',
        panelStyle: 'panel-default',
        data: {}
    }